import { Component, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { MessageEvent, SignInEvent, OpenFrameEvent, LoaderEvent, HiddenFooter, SetAllMemberCheck } from './../../shared/message.event';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { UISETTING } from './../../shared/ui-setting';
import { UtilityFunctions } from '../../shared/utility-functions';
import { LoyaltyService } from '../loyalty.service';
import { ISlimScrollOptions } from 'ng2-slimscroll';
@Component({
  selector: 'app-loyalty-summary-list',
  templateUrl: './summary-list.component.html',
  styleUrls: ['./summary-list.component.css'],
  providers: []
})
export class LoyaltySummaryListComponent implements OnInit {
  private stringConstants = CONSTANT_MESSAGES;
  private shouldSlide: boolean = false;
  private hideEdit: boolean;
  private pagebutton = 30;
  private noMemberAvailable: boolean = true;
  private utilityFunctions = new UtilityFunctions;

  private selectMember = false;
  private exp = false;
  private disableSelectMember = false;
  tableVariable: any = {};
  private totalSizeOfList = 0;
  private pageOptions = {
    currentPage: 1,
    noOfPageItem: 10
  };
  private memberTableHeight = 65;
  private noMemberAvailableInFilter = false;
  private openSubMenu3 = false;
  private uiSetting: UISETTING;
  private height: any
  private searchMember = '';
  vendor: any;
  clubName: any;
  private popUpMessage = '';
  protected filterState = '';
  message = '';
  timezoneOffset: any;
  summaryList = [];
  spentDetails: any;
  currentPage = 1;

  private windowHeight = window.innerHeight;
  allInGroup1 = false;
  memberPointer = false;
  CheckedMembers: any
  allMembersChecked: any;
  changePage: any;
  showDetails = false;
  totalListCount = 0;
  private totalPage = 0;
  perPageItemSize = 0;
  statusMember = true;
  private rowItemSizes = [10];
  private noOfPageItem = 10;  // It will set by vendor configuration object
  startDate: any;
  endDate: any;
  private topNav = 56;
  private midNav = 45;
  private footer = 35;
  private container = 20;
  private divHeight = 30;
    private scrollOptions: ISlimScrollOptions;
  constructor(private router: Router,
    private openFrameEvent: OpenFrameEvent, private messageEvent: MessageEvent, private loyaltyService: LoyaltyService, private loaderEvent: LoaderEvent, private _router: Router) {
      this.scrollOptions = {
        barBackground: "#343a40", 
        barOpacity: "0.6", 
        position: "right",
        barWidth: "6", barBorderRadius: "5", barMargin: "1px 1px", 
        gridBackground: "#adb5bd", gridOpacity: "1", 
        gridWidth: "4", gridBorderRadius: "10", 
        gridMargin: "1px 2px",
      };
    this.uiSetting = {
      'windowHeight': window.innerHeight,
      'topNav': 0,
      'midNav': 0,
      'footer': 0,
      'container': 0
    }
    this.hideEdit = false;
    this.height = (this.windowHeight - (this.topNav + this.midNav + this.container + this.footer + this.divHeight)) + 'px';
    this.selectMember = false;


    if (localStorage.getItem('vendor')) {
      this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
      this.timezoneOffset = this.vendor.timezoneOffset * -1;
      this.clubName = this.vendor.clubName;
    }
  }

  ngOnInit() {
    let timeZoneDate, year, month, date, day, hour, minutes;

    timeZoneDate = moment().utcOffset(this.timezoneOffset);
    year = timeZoneDate.year(), month = timeZoneDate.month(), date = timeZoneDate.date(), hour = timeZoneDate.hour(), minutes = timeZoneDate.minutes();

    this.startDate = (new Date(year, month, date, 0, 0, 0, 0));
    this.endDate = (new Date(year, month, date, 24, 0, 0, 0));

    this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
    this.clubName = this.vendor.clubName;
    this.pagination(this.pageOptions, 1);
  }


  onDateSelect(popUpObj) {
    if ((this.searchMember + '').trim()) {
      this.pagination(this.pageOptions, 1, popUpObj);
    } else {
      this.searchMember = '';
      this.pagination(this.pageOptions, 1), popUpObj;
    }
  }

  getSummaryList(request) {
    try {
      this.loaderEvent.fire(false);
      let that = this;
      this.loyaltyService.getMemberVisitStats(request).then((result: any) => {
        if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
          this.spentDetails = result.spentDetails;
          this.summaryList = result.data;

          this.totalSizeOfList = result.total;
          this.noMemberAvailable = (result.total > 0);

          this.totalPage = Math.ceil(this.totalSizeOfList / this.noOfPageItem);
          if (this.summaryList.length === 0) {
            this.noMemberAvailable = false;
          } else {
            this.noMemberAvailable = true;
          }
          if (request['filters'].length > 0) {
            this.noMemberAvailableInFilter = true;
          } else {
            this.noMemberAvailableInFilter = false;
          }
          this.loaderEvent.fire(true);
        }
      }).catch((err) => {
        this.popUpMessage = err;
        this.loaderEvent.fire(true);
      });
    } catch (e) {
      console.log(e);
    }
  }

  showDetail(item) {
    try {
      localStorage.setItem('memberSummary', btoa(JSON.stringify(item)));
      this._router.navigate(['/loyalty-details']);
    } catch (e) {
      console.log(e);
    }
  }

  navigateToScan(){
    // window.open 
  }

  pageChangeClick(currentPage, noOfPageItem) {
    if ((noOfPageItem + '').indexOf(':') > -1) {
      this.noOfPageItem = noOfPageItem.split(':')[1].trim();
      currentPage = 1;
    } else {
      this.noOfPageItem = noOfPageItem;
    }
    this.currentPage = currentPage;
    let pageOptions = {
      currentPage: this.currentPage,
      noOfPageItem: this.noOfPageItem
    };
    this.pagination(pageOptions, null)
  }


  emitOpenFrameEvent() {
    this.openFrameEvent.fire(false);
  }



  /*
   * function for expand search input tag
   */
  expand() {
    if ((this.searchMember + '').trim()) {
      this.pagination(this.pageOptions, 1);
    } else {
      this.searchMember = '';
      if (this.exp) {
        this.pagination(this.pageOptions, 1);
      }
      this.exp = !this.exp;
    }
  }

  disableSelectMemberOnCheck(bool: boolean) {
    if (!this.disableSelectMember) {
      this.disableSelectMember = bool;
    }
  }

  /*
   * Pagination is done on no of items in one page and current page
   */
  pagination(pageOptions, pageNo, popUpObj?: any) {
    const eventStart = moment(this.startDate).utcOffset(this.timezoneOffset).set({ 'hour': 0, 'second': 0, 'minute': 0, 'millisecond': 0 });
    const eventEnd = moment(this.endDate).utcOffset(this.timezoneOffset).set({ 'hour': 24, 'second': 0, 'minute': 0, 'millisecond': 0 });
    if (eventStart.isBefore(eventEnd)) {
      //  this.filterState = this.filterPara;
      if (pageOptions) {
        this.pageOptions = pageOptions;
      }
      let requestObject = {} as any;
      requestObject = this.setVendorIdAsPerRole(pageNo);
      requestObject.startDate = eventStart;
      requestObject.endDate = eventEnd;
      this.tableVariable.currentPage = pageNo ? pageNo : this.pageOptions.currentPage;
      this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;

      if ((this.searchMember + '').trim()) {
        requestObject['filters'].push({
          type: 'search',
          values: this.searchMember
        });
        this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
      }
      localStorage.setItem('selectedStartDate', requestObject.startDate);
      localStorage.setItem('selectedEndDate', requestObject.endDate);
      this.getSummaryList(requestObject);
    } else {
      this.loaderEvent.fire(true);
      if (popUpObj) {
        this.popUpMessage = CONSTANT_MESSAGES.START_DATE_LESS_ERROR_MESSAGE;
        popUpObj.showChildModal();
      }
    }
  }

  setVendorIdAsPerRole(pageNo) {
    let requestObject = {
      'vendorId': '',
      perPage: this.pageOptions.noOfPageItem,
      pageNumber: pageNo ? pageNo : this.pageOptions.currentPage,
      filters: []
    };
    if (this.vendor.role === CONSTANT_VALUES.ROLE_VENDOR_ADMIN) {
      requestObject['vendorId'] = this.vendor._id;
    } else if (this.vendor.role === CONSTANT_VALUES.SUPER_ADMIN) {
      let subVendor = this.vendor.subVendors[0];
      requestObject['vendorId'] = subVendor._id;
    } else if (this.vendor.role === CONSTANT_VALUES.ROLE_STAFF) {
      requestObject['vendorId'] = this.vendor.vendorId;
    } 
    return requestObject;
  }


  /*
   * Select category for filter
   */
  setFilterCriteria(para) {
    this.utilityFunctions.setFilterCriteria(this, para);
  }


}



// WEBPACK FOOTER //
// ./src/app/loyalty/summary-list/summary-list.component.ts